import { connect } from 'react-redux'
import * as action from '../../state/task-definition/action'
import * as selector from '../../state/task-definition/selector'
import TaskDefinition from './TaskDefinition'


const mapStateToProps = state => {
    return {
        taskDefinitionList: selector.selectTaskDefinitionList(state),
    }
}

const mapDispatchToProps = {
    findTaskDefinitionList: action.findTaskDefinitionList,
    changeTaskDefinition: action.changeTaskDefinition,
    saveTaskDefinition: action.saveTaskDefinition,
}


export default connect(mapStateToProps, mapDispatchToProps)(TaskDefinition)



// WEBPACK FOOTER //
// ./src/modules/process/component/task-definition/TaskDefinitionContainer.js